/* eslint-disable import/prefer-default-export */

// eslint-disable-next-line max-len
export const numberAfterPoint = (num) =>
  num?.toString().includes('.') ? num?.toString().split('.').pop().length : 0;
